export default __webpack_public_path__ + "static/media/close-bold.b2f5a374.svg";